// extracted by mini-css-extract-plugin
export default {"searchBorder":"SearchLocation_searchBorder__9M0MX"};